export default [
  {
    path: '/baogaolist',
    meta: { title: '报告查询', keepAlive: true },
    component: () => import(/* webpackChunkName: "baogao" */ '../views/baogao/baogaoList')
  },
  {
    path: '/baogaoDetail',
    meta: { title: '报告详情' },
    component: () => import(/* webpackChunkName: "baogao" */ '../views/baogao/baogaoDetail')
  },
  {
    path: '/baogaoJcDetail',
    meta: { title: '检查报告详情' },
    component: () => import(/* webpackChunkName: "baogao" */ '../views/baogao/baogaoJcDetail')
  }
]
